import { render, staticRenderFns } from "./AllowTime.vue?vue&type=template&id=256a6b78&"
import script from "./AllowTime.vue?vue&type=script&lang=js&"
export * from "./AllowTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports